import React from 'react'
import styles from './container.module.scss'

export default ({ children, variant = 'default' }) => (
  <div className={styles[variant]}> {children} </div>
)
